// Calendar Controller
PictureCalendarController.$inject = ['$scope','pictureService'];
function PictureCalendarController($scope, pictureService){
    let eventsCopy = [];
    $scope.events       = [];
    $scope.calendarView = 'month';
    $scope.calendarDate = new Date();
    $scope.filter = "All";

    pictureService
    .findEvents()
    .then(events => $scope.events = eventsCopy = events);


    $scope.updateCalendar = updateCalendar
    $scope.openEvent = pictureService.openEvent;

    function updateCalendar(countryName){
        let country = _.toUpper($scope.filter);

        if(country === _.toUpper("brazil")) $scope.events = _.filter(eventsCopy, (ev) => ev.title.indexOf("Brazil") > -1);
        if(country === _.toUpper("india"))  $scope.events = _.filter(eventsCopy, (ev) => ev.title.indexOf("India") > -1);
        if(country === _.toUpper("china"))  $scope.events = _.filter(eventsCopy, (ev) => ev.title.indexOf("China") > -1);
        if(country === _.toUpper("all"))  $scope.events = eventsCopy;
    }

    $scope.showNewPicturesAlert = false;
    if(moment().isBefore(moment('2016-11-22'))){
        $scope.showNewPicturesAlert = true;
    }else{
        $scope.showNewPicturesAlert = false;
    }
}

function PictureListController($scope, $routeParams, pictureService){
    $scope.pos = [];
    $scope.stats = {}
    $scope.pictureFilter = false;

    let findPoList = () => {
        pictureService.findPoList().then(pos => {
            $scope.pos = pos
            $scope.stats.downloaded = _.filter(pos, po => po.isDownloaded === true).length;
            $scope.stats.nonDownloaded = pos.length - $scope.stats.downloaded;
        });
    }

    function filterDownloaded(item){
        if($scope.pictureFilter == true) return true;
        if($scope.pictureFilter == false) return item.isDownloaded == false;
    }

    $scope.downloadPictures = pos => {
      pictureService.downloadPictures(pos, void 0)//.then(() => findPoList())
    }
    $scope.downloadNonDownloaded = pictureService.downloadNonDownloaded
    $scope.downloadBulk = pictureService.downloadBulk
    $scope.filterDownloaded = filterDownloaded;

    findPoList();
}

function PictureModalController($scope, $uibModalInstance, pictureService, calendarEvent){
    $scope.POs       = [];
    $scope.eventDate = new Date(calendarEvent.startsAt);
    $scope.calendarEvent = calendarEvent;

    function ok()       { $uibModalInstance.close() };
    function close()    { $uibModalInstance.dismiss('cancel') };

    function findPOs(){
        pictureService.findPOs(calendarEvent)
        .then(pos => $scope.POs = pos);
    };
    findPOs();

    $scope.ok = ok;
    $scope.close = close;
    $scope.downloadPictures = (pos, date) => { pictureService.downloadPictures(pos,date).then(() => findPOs()); };
}

function PictureNewController($scope, pictureService){
}

PictureNewController.$inject = ['$scope','pictureService']
PictureListController.$inject = ['$scope','$routeParams','pictureService']
PictureModalController.$inject = ['$scope','$uibModalInstance','pictureService','calendarEvent']

app.controller('PictureCalendarController', PictureCalendarController)
app.controller('PictureNewController',  PictureNewController)
app.controller('PictureListController', PictureListController)
app.controller('PictureModalController', PictureModalController)
